import { FC } from 'react'
import { Sticky as RSSticky, StickyProps as RSStickyProps } from 'react-sticky'

interface StickyProps extends RSStickyProps{
  enabled?: boolean;
}

const Sticky: FC<StickyProps> = ({
  enabled,
  children,
  ...restProps
}) => enabled ? (
  <RSSticky {...restProps}>
    {children}
  </RSSticky>
) : (
  <>
    {children({
      style: {},
      isSticky: false,
      wasSticky: false,
      distanceFromBottom: 0,
      distanceFromTop: 0,
      calculatedHeight: 0,
    })}
  </>
)

export default Sticky
